import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  MoveDownOutlined as MoveDownOutlinedIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Pagination,
  Stack,
  TableCell,
  TableFooter,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import GetInformation from "./GetInformation";
import MomTable from "./momTable.jsx";
import PairTable from "./pairTable.jsx";
import PairTableSynnex from "./pairTableSynnex.jsx";
import { ocrModel2Agency } from "./Sidebar.jsx";

export const MOM_STATUS_INITIAL = -1; //初期値
export const MOM_STATUS_RUNNING = 0; //実行中
export const MOM_STATUS_PDF_ERROR = 1; //PDF展開エラー
export const MOM_STATUS_OCR_ERROR = 2; //OCRエラー
export const MOM_STATUS_PAIR_ERROR = 3; //書類対判定エラー
export const MOM_STATUS_ORDERFORM_ERROR = 4; // 申請書エラー
export const MOM_STATUS_MOM_CHECK_REQ = 5; // MOM登録待ち
export const MOM_STATUS_MOM_API_ERROR = 6; // MOM APIエラー
export const MOM_STATUS_NO_USE = 7; //
export const MOM_STATUS_COMPLETED = 8; // MOM登録完了
export const MOM_STATUS_UNDEFINE = 99; // URL呼び出し(Staus未定義)

export const WITH_MOM_REGISTRATION = 1; // MOM登録あり
export const WITHOUT_MOM_REGISTRATION = 0; // MOM登録なし

const procStatuses = [
  /*　使用　 確認　 編集　 C/P(Completed/Processing)  */
  /*　 ◯　　　X 　　　　 　 P　 */ { id: 0, content: "実行中" },
  /*　 X　　　　　　　　 　 P　 */ { id: 1, content: "PDF展開エラー" },
  /*　 ◯　　　x 　　　　 　 P　 */ { id: 2, content: "OCRエラー" },
  /*　 ◯　　　◯　　　◯　 　 P　 */ { id: 3, content: "書類対判定エラー" },
  /*　 X　　　　　　　　 　 P　 */ { id: 4, content: "申請書エラー" },
  /*　 ◯　　　◯　　　◯　 　P 　 */ { id: 5, content: "MOM登録待ち" },
  /*　 ◯　　　◯　　　x　 　P 　 */ { id: 6, content: "MOM APIエラー" },
  /*　 x 　　　　　　　　　 　 */ { id: 7, content: "" },
  /*　 ◯　　　◯　　　x 　　C 　 */ { id: 8, content: "MOM登録完了" },
];

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Tokyo");

const theme = createTheme({
  typography: {
    fontSize: 12, // ここで全体のフォントサイズを設定
  },
});

export default function ProcStatusList(props) {
  const [procStatusLists, setprocStatusLists] = useState(); // listとsetListをuseStateで初期化
  const [page, setPage] = useState(0); // 現在のページ
  const [rowsPerPage, setRowsPerPage] = useState(10); // 1ページあたりの行数
  const [momArray, setMomArray] = useState([]);
  const [formPairList, setFormPairList] = useState({});
  const [sortOrder, setSortOrder] = useState({
    name: "uploadDate", // ソートされる列の名前
    direction: "desc", // ソート方向 ("asc" or "desc")
  });

  const [startAction, setStartAction] = useState({
    processNo: null, // 管理番号
    actionKind: MOM_STATUS_INITIAL, // アクションの種類
    argency: "", // 流通販社
  });
  const [isSubmitting, setIsSubmitting] = useState(false); // ボタン連打防止（ボタン非活性化）
  const [showTable, setShowTable] = useState(true);
  const [isMomEditting, setIsMomEditting] = useState(null);

  const webApiUrl = process.env.REACT_APP_LAMBDA_API_URL; // LambdaのAPI URL
  const location = useLocation();
  const isUrlParamProcessNo = useRef(false);

  const [userEmail, setUserEmail] = useState(""); // ログインユーザーEmail
  const [, setUserName] = useState(""); // ログインユーザー名
  const [, setCookie, removeCookie] = useCookies(); // Cookieのユーザー権限
  const [, setVersionId] = useState(null); // バージョンIDの管理

  // ページ変更時
  const handleChangePage = (event, pageNo) => {
    // setPageChangeClicked(true);
    setPage(pageNo - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event);
    setPage(0);
  };

  // ウィンドウサイズを変更する関数
  const simulateResizeEvent = () => {
    const event = new Event("resize");
    window.dispatchEvent(event);
  };

  // マウント時に1回だけ実行
  useEffect(() => {
    // データ取得
    getProcStatusLists();

    const queryParams = new URLSearchParams(location.search);
    const queryParamProcessNo = queryParams.get("processNo");
    if (queryParamProcessNo !== null) {
      handleMomCheckStart(queryParamProcessNo, MOM_STATUS_UNDEFINE);
      isUrlParamProcessNo.current = true;
    } else {
      isUrlParamProcessNo.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 指定されたprocessNoをprocStatusLists.statusProcesses.processNo から見つけて、statusを辺値する
  function retStatusByProcessNo(processNo) {
    if (!procStatusLists) return null;
    const index = procStatusLists.statusProcesses.findIndex(
      (item) => item.statusProcess.processNo === processNo
    );
    if (index !== -1) {
      setStartAction({
        processNo: processNo,
        actionKind: procStatusLists.statusProcesses[index].statusProcess.status,
      });

      return startAction.actionKind;
    }
    return null;
  }

  // URL クエリーパラメータの追加・削除
  function updateQueryParameter(key, value) {
    const queryParams = new URLSearchParams(window.location.search);
    if (value === null || value === undefined) {
      queryParams.delete(key);
    } else {
      queryParams.set(key, value);
    }
    const newUrl = queryParams.toString()
      ? "?" + queryParams.toString()
      : window.location.pathname;
    window.history.replaceState(null, null, newUrl);
  }

  /*************************************************************************************************************************
    処理状況一覧取得
  **************************************************************/
  async function getProcStatusLists() {
    try {
      const apiUrl = `${webApiUrl}/getProcStatusLists`;
      const headers = {
        "Content-Type": "application/json",
      };
      const requestData =
        props.procMode === "Completed"
          ? {
              params: {
                termStartDate: termDate.start,
                termEndDate: termDate.end,
              },
            }
          : {
              params: {
                termStartDate: "",
                termEndDate: "",
              },
            };
      console.log("API call (getProcStatusLists request", requestData);
      const response = await axios.get(apiUrl, requestData, { headers });
      console.log("API call (getProcStatusLists response", response);

      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        throw new Error(
          "getProcStatusLists API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }

      // response.data.body.statusProcesses[292].statusProcess.status = 3;
      const items = response.data.body;

      // ３時間以内に登録した申請書が「実行中」の場合、自動更新を開始する
      let Hour3Ago = new Date(new Date().getTime() - 3 * 60 * 60 * 1000);

      let runningStatus = items.statusProcesses.some((item) => {
        return (
          item.statusProcess.status === MOM_STATUS_RUNNING &&
          new Date(item.statusProcess.uploadDate) >= Hour3Ago
        );
      });

      setIsTimer(runningStatus);

      setprocStatusLists(items);
    } catch (error) {
      if (error.response) {
        const { status, statusText } = error.response;
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
      }
    }
  }

  /*************************************************************
    処理状況一覧更新
  **************************************************************/
  const [isTimer, setIsTimer] = useState(false);
  const timerId = useRef(null);

  const handleUpdateClick = () => {
    getProcStatusLists();
  };

  useEffect(() => {
    if (isTimer) {
      timerId.current = setInterval(() => {
        getProcStatusLists();
      }, 3000); // 3秒ごとに呼び出す
    } else if (!isTimer && timerId.current) {
      clearInterval(timerId.current); // タイマーをクリア
      timerId.current = null; // タイマーIDをリセット
    }
    return () => {
      if (timerId.current) {
        clearInterval(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTimer]);

  /*************************************************************************************************************************
    エラー確認（書類の対エラー）
  **************************************************************/

  // 書類の対エラー 取得
  async function getErrPairInformation(processNo, argency) {
    try {
      const apiUrl =
        argency === "SYNNEX"
          ? `${webApiUrl}/getErrPairSynnex`
          : `${webApiUrl}/getErrPair`;
      const headers = {
        "Content-Type": "application/json",
      };
      const requestData = { params: { processNo: processNo } };
      console.log("API call (getErrPair request", requestData);
      const response = await axios.get(apiUrl, requestData, { headers });
      console.log("API call (getErrPair response", response);
      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        throw new Error(
          "getErrPair API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }

      const items = response.data.body;

      setFormPairList(items);
    } catch (error) {
      if (error.response) {
        const { status, statusText } = error.response;
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
      }
    }
  }

  // 書類の対エラー 登録
  async function putErrPairInformation(processNo, argency, pairInfo) {
    try {
      const apiUrl = `${webApiUrl}/execProc`;
      const headers = {
        "Content-Type": "application/json",
      };

      let requestData;
      if (argency !== "SYNNEX") {
        requestData = {
          processNo: processNo,
          execMode: 1,
          oks: pairInfo,
        };
      } else {
        // SYNNEX
        requestData = {
          processNo: processNo,
          execMode: 2,
          pageConfiguration: pairInfo,
        };
      }

      console.log("API call (execProc(execMode1) request", requestData);
      const response = await axios.post(apiUrl, requestData, { headers });
      console.log("API call (execProc(execMode1) response", response);
      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        throw new Error(
          "execProc(execMode1 API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }
    } catch (error) {
      if (error.response) {
        const { status, statusText } = error.response;
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
      }
    }
  }

  const handleSetErrPair = async (processNo, argency) => {
    setIsSubmitting(true); // ボタン非活性化

    await getErrPairInformation(processNo, argency);
    setStartAction({
      processNo: processNo,
      actionKind: MOM_STATUS_PAIR_ERROR,
      argency: argency,
    });
    setIsSubmitting(false); // ボタン活性化
    setShowTable(false); // 処理状況一覧非表示
    window.scrollTo(0, 0);
    setFilterArgency("");
    setFilterProcSts("");
  };

  const handlePairFormRegistration = async () => {
    setIsSubmitting(true); // ボタン非活性化

    let pageInfo = JSON.parse(JSON.stringify(formPairList));
    let pageInfoUnique;

    if (startAction.argency !== "SYNNEX") {
      if (!pageInfo.oks) {
        pageInfo.oks = [];
      }
      // ngPos が undefined の場合に対応
      if (pageInfo.ngPos && pageInfo.ngPos.length > 0) {
        for (let i = 0; i < pageInfo.ngPos.length; i++) {
          pageInfo.oks.push({
            ok: {
              poPath: pageInfo.ngPos[i].path,
              ofPath: pageInfo.ngOfs[i].path,
            },
          });
        }
      }
      delete pageInfo.ngPos;
      delete pageInfo.ngOfs;
      pageInfoUnique = pageInfo.oks;
    } else {
      pageInfo.pageConfiguration.forEach((item) => {
        delete item.thumbnailPath;
      });
      pageInfoUnique = pageInfo.pageConfiguration;
    }

    await putErrPairInformation(
      startAction.processNo,
      startAction.argency,
      pageInfoUnique
    );
    setStartAction({
      processNo: null,
      actionKind: MOM_STATUS_INITIAL,
      argency: "",
    });
    setIsSubmitting(false); // ボタン活性化
    handleUpdateClick();
    setShowTable(true); // 処理状況一覧表示
    window.scrollTo(0, 0);
  };

  const onSavePairForm = (newData) => {
    setFormPairList(newData);
  };

  /*************************************************************
    確認編集キャンセル（MOM登録、書類の対エラー）
  **************************************************************/
  const handleEditRecordCancel = () => {
    const saveActionKind = startAction.actionKind;

    setStartAction({
      processNo: null,
      actionKind: MOM_STATUS_INITIAL,
      argency: "",
    });
    setShowTable(true); // 処理状況一覧表示

    getProcStatusLists();
    setFilterArgency(filterArgencyBackup);
    setFilterProcSts(filterProcStsBackup);

    window.scrollTo(0, 0);

    updateQueryParameter("processNo", null); //URLクエリーパラメータの削除

    if (isUrlParamProcessNo.current === false) {
      return;
    }

    // URLパラメータ指定があった場合は、メニューを初期化したいためリロードさせる
    isUrlParamProcessNo.current = false;
    const url = new URL(window.location);
    const saveOrgHref = url.href;
    if (saveActionKind === MOM_STATUS_COMPLETED) {
      url.href = `${url.origin}/procEndStatusLists`;
    } else {
      url.href = `${url.origin}/procStatusLists`;
    }
    if (saveOrgHref !== url.href) {
      window.location.href = url.toString();
    }
  };

  /*************************************************************************************************************************
    MOM 取得
  **************************************************************/

  // MOM情報取得
  async function getMomInformation(processNo) {
    try {
      const apiUrl = `${webApiUrl}/getMom`;
      const headers = {
        "Content-Type": "application/json",
      };
      const requestData = { params: { processNo: processNo } };
      console.log("API call (getMom request", requestData);
      const response = await axios.get(apiUrl, requestData, { headers });
      console.log("API call (getMom response", response);

      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        throw new Error(
          "getMom API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }

      if (response.data === false) {
        throw new Error("uploadFileExec response data：false");
      }
      const items = response.data.body;
      // items.momInfos[0].momInfo.mfProductName = "スタンダードプラン";
      items.momInfos = items.momInfos.map((item) => ({
        ...item,
        momInfo: {
          ...item.momInfo,
          agency: Number(item.momInfo.agency), // 流通販社
          checkCompany: Number(item.momInfo.checkCompany), // 会社名
          checkMail: Number(item.momInfo.checkMail), // メールアドレス
          checkOrderCount: Number(item.momInfo.checkOrderCount), // 注文数
          checkProductNo: Number(item.momInfo.checkProductNo), // 商品番号
          isRegistSalesAgentInfo: Number(item.momInfo.isRegistSalesAgentInfo), // 販社情報登録
        },
      }));
      setMomArray(items);

      return true;
    } catch (error) {
      if (error.response) {
        const { status, statusText } = error.response;
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
      }
      return false;
    }
  }

  /*************************************************************
    MOM 確認
  **************************************************************/
  const handleMomCheckStart = async (processNo, actionKind) => {
    setIsSubmitting(true); // ボタン非活性化
    if ((await getMomInformation(processNo)) === false) {
      setIsSubmitting(false); // ボタン活性化
      return;
    }
    setStartAction({
      processNo: parseInt(processNo),
      actionKind: parseInt(actionKind),
    });
    setIsSubmitting(false); // ボタン活性化

    setShowTable(false); // 処理状況一覧非表示
    window.scrollTo(0, 0);
    setFilterArgency("");
    setFilterProcSts("");

    updateQueryParameter("processNo", processNo); //URLクエリーパラメータの追加
  };

  /*************************************************************
    MOM 登録
  **************************************************************/

  const handleMomRegistrationCore = async (processNo, momRegist, momArray) => {
    const webApiUrl = process.env.REACT_APP_LAMBDA_API_URL; // LambdaのAPI URL
    const apiUrl = `${webApiUrl}/putMom`;
    let responseErrCode = 200;
    try {
      const newMomArray = JSON.parse(JSON.stringify(momArray)); // ステートのディープコピーを作成
      newMomArray.momBaseInfo.processNo = processNo;
      newMomArray.momBaseInfo.momRegisterMail = userEmail;
      newMomArray.momBaseInfo.momRegistration = momRegist; // 常にMOM登録あり
      newMomArray.momBaseInfo.isCompleted = 1; // 常に完了ステイタス

      newMomArray.momInfos = newMomArray.momInfos.map(({ momInfo }) => ({
        momInfo: {
          id: momInfo.id,
          purchaseNo: momInfo.purchaseNo,
          agencyOrderNo: momInfo.agencyOrderNo,
          company: momInfo.company,
          department: momInfo.department,
          contactPerson: momInfo.contactPerson,
          prefectures: momInfo.prefectures,
          city: momInfo.city,
          town: momInfo.town,
          street: momInfo.street,
          building: momInfo.building,
          tel: momInfo.tel,
          remarks: momInfo.remarks,
          momProcStatus: momInfo.momProcStatus,
          isRegistSalesAgentInfo: momInfo.isRegistSalesAgentInfo,
        },
      }));

      const requestData = newMomArray;
      const headers = {
        "Content-Type": "application/json",
      };

      console.log("API call (putMom request", requestData);
      const response = await axios.put(apiUrl, requestData, { headers });
      console.log("API call (putMom response", response);

      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        responseErrCode = response.data.code;
        throw new Error(
          "putMom API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }
    } catch (error) {
      if (responseErrCode === 420) {
        alert(
          "MOM がビジー状態のため、しばらく待ってから再度 [MOM 登録] を実施してください"
        );
      } else if (error.response) {
        const { status, statusText } = error.response;
        const statusTextMessage = statusText ? ` ${statusText}` : "";
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status}${statusTextMessage}`);
        // HTTP 504 エラーは通知しない（利用者への影響を最小限に）
        // 業務エラー（420など）は通知、HTTP系エラーで 504 のみ非通知
        if (status !== 504) {
          alert(
            `MOM登録でエラーが発生しました。（HTTP ${status}${statusTextMessage}）`
          );
        }
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
        alert(`MOM登録でエラーが発生しました。（${error.message}）`);
      }
    } finally {
      if (momRegist === WITH_MOM_REGISTRATION)
        updateQueryParameter("processNo", null); //URLクエリーパラメータの削除
    }
  };

  const handleMomRegistration = async () => {
    setIsSubmitting(true); // ボタン非活性化
    const saveActionKind = startAction.actionKind;
    await handleMomRegistrationCore(
      startAction.processNo,
      WITH_MOM_REGISTRATION,
      momArray
    );
    setStartAction({
      processNo: null,
      actionKind: MOM_STATUS_INITIAL,
      argency: "",
    });
    setIsSubmitting(false); // ボタン活性化

    getProcStatusLists();
    setShowTable(true); // 処理状況一覧表示

    window.scrollTo(0, 0);

    updateQueryParameter("processNo", null); //URLクエリーパラメータの削除

    if (isUrlParamProcessNo.current === false) {
      return;
    }

    // URLパラメータ指定があった場合は、メニューを初期化したいためリロードさせる
    isUrlParamProcessNo.current = false;
    const url = new URL(window.location);
    const saveOrgHref = url.href;
    if (saveActionKind === MOM_STATUS_COMPLETED) {
      url.href = `${url.origin}/procEndStatusLists`;
    } else {
      url.href = `${url.origin}/procStatusLists`;
    }
    if (saveOrgHref !== url.href) {
      window.location.href = url.toString();
    }
  };

  const onSaveMomData = async (newData) => {
    const saveData = JSON.parse(JSON.stringify(momArray));

    // 見積もり番号が変更されたかどうかを判定
    const newPurchaseNos = newData.map((item) => item.momInfo.purchaseNo);
    const savePurchaseNos = saveData.momInfos.map(
      (item) => item.momInfo.purchaseNo
    );
    const changePurchaseNoFlag =
      JSON.stringify(newPurchaseNos) === JSON.stringify(savePurchaseNos)
        ? false
        : true;

    // 見積もり番号が変更された場合、MOM情報（MF見積DB情報）をクリア
    if (changePurchaseNoFlag) {
      const differentPurchaseNos = newPurchaseNos.filter(
        (purchaseNo) => !savePurchaseNos.includes(purchaseNo)
      );
      const updatedMomInfos = newData.filter((item) =>
        differentPurchaseNos.includes(item.momInfo.purchaseNo)
      );
      updatedMomInfos.forEach((item) => {
        const msg = "取得中...";
        item.momInfo.mfMail = msg;
        item.momInfo.mfCompany = msg;
        item.momInfo.mfProductName = "スタンダードプラン";
        item.momInfo.mfProductNo = msg;
        item.momInfo.mfOrderCount = msg;
      });
    }

    // MOM情報を保存呼び出し（putMom）
    saveData.momInfos = newData;
    setMomArray(saveData);
    await handleMomRegistrationCore(
      startAction.processNo,
      WITHOUT_MOM_REGISTRATION,
      saveData
    );

    // 見積もり番号が変更された場合、MOM情報（MF見積DB情報）を取得
    if (changePurchaseNoFlag) {
      if ((await getMomInformation(startAction.processNo)) === false) {
        return;
      }
    }
  };

  const onSaveBaseMomData = async (newData) => {
    const saveData = JSON.parse(JSON.stringify(momArray));
    saveData.momBaseInfo = newData;
    setMomArray(saveData);
    await handleMomRegistrationCore(
      startAction.processNo,
      WITHOUT_MOM_REGISTRATION,
      saveData
    );
  };

  const handleSetAllProcEndStatus = async () => {
    if (
      window.confirm(
        "処理状況が「ーーー」のすべてを「受注完了」に設定します。\n実行してもいいですか？"
      )
    ) {
      const savMomArray = {
        ...momArray,
        momInfos: momArray.momInfos.map((item) => {
          let procStatus;
          if (parseInt(item.momInfo.momProcStatus) === 0) {
            procStatus = "1";
          } else {
            procStatus = item.momInfo.momProcStatus;
          }

          return {
            ...item,
            momInfo: {
              ...item.momInfo,
              momProcStatus: procStatus,
            },
          };
        }),
      };

      setMomArray(savMomArray);
      await handleMomRegistrationCore(
        startAction.processNo,
        WITHOUT_MOM_REGISTRATION,
        savMomArray
      );

      return;
    }
  };

  /*************************************************************************************************************************
    レコード削除
  **************************************************************/

  const handDeleteRecordCore = async (processNo) => {
    const webApiUrl = process.env.REACT_APP_LAMBDA_API_URL; // LambdaのAPI URL
    const apiUrl = `${webApiUrl}/deleteData`;
    try {
      const requestData = {
        processNo: parseInt(processNo),
      };
      const headers = {
        "Content-Type": "application/json",
      };

      console.log("API call (deleteData request", requestData);
      const response = await axios.delete(
        apiUrl,
        { data: requestData },
        { headers }
      );
      console.log("API call (deleteData response", response);

      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        throw new Error(
          "deleteData API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }

      getProcStatusLists();
    } catch (error) {
      if (error.response) {
        const { status, statusText } = error.response;
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
      }
    }
  };

  const handleDelete = async (processNo) => {
    if (window.confirm("本当に削除しますか？")) {
      setIsSubmitting(true); // ボタン非活性化
      await handDeleteRecordCore(processNo);
      handleUpdateClick();
      setIsSubmitting(false); // ボタン活性化
    }
  };

  /*************************************************************
    強制完了処理
  **************************************************************/
  const handMoveRecordCore = async (processNo) => {
    const webApiUrl = process.env.REACT_APP_LAMBDA_API_URL; // LambdaのAPI URL
    const apiUrl = `${webApiUrl}/putForceCompletion`;
    try {
      const requestData = {
        processNo: processNo,
        forceCompletion: 1,
      };
      const headers = {
        "Content-Type": "application/json",
      };

      console.log("API call (putForceCompletion request", requestData);
      const response = await axios.put(apiUrl, requestData, { headers });
      console.log("API call (putForceCompletion response", response);

      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        throw new Error(
          "putForceCompletion API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }
    } catch (error) {
      if (error.response) {
        const { status, statusText } = error.response;
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
      }
    } finally {
    }
  };

  const handleMove = async (processNo) => {
    if (window.confirm("完了にしますか？")) {
      setIsSubmitting(true); // ボタン非活性化
      await handMoveRecordCore(processNo);
      handleUpdateClick();
      setIsSubmitting(false); // ボタン活性化
    }
  };

  const buttonStyles = { margin: "3px" };
  const isDisabled = startAction.processNo === null ? false : true;

  const ConfirmButton = ({ color, variant, onClick, label = "確認" }) => (
    <Button
      variant={variant}
      color={color}
      disabled={isDisabled || isSubmitting || isEditingTermDate}
      onClick={onClick}
      style={buttonStyles}
    >
      {label}
    </Button>
  );

  const removeYearFromDate = (dateString) => {
    if (dateString === "") {
      return "";
    }
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const time = date.toTimeString().split(" ")[0]; // 時間部分のみ取得
    return `${month}-${day} ${time}`;
  };

  /***************************************************
  // MOM 登録日表示期間の編集
  *****************************************************/
  const [termDate, setTermDate] = useState({
    start: dayjs().subtract(3, "month").format("YYYY/MM/DD"), // 表示期間：開始（3ヶ月前）
    end: dayjs().format("YYYY/MM/DD"), // 表示期間：終了
  });
  const [isEditingTermDate, setIsEditingTermDate] = useState(false);
  const [initialTermDate, setInitialTermDate] = useState(termDate); // 初期状態を保存

  const handleEditTermDateStart = () => {
    setInitialTermDate(termDate); // 編集開始時に初期値を保存
    setIsEditingTermDate(true); // 編集モードを有効化
  };

  const handleTermDateChange = () => {
    getProcStatusLists();
    setIsEditingTermDate(false); // 編集モードを終了
  };

  const handleEditTermDateCancel = () => {
    setTermDate(initialTermDate); // 戻る時に初期値にリセット
    setIsEditingTermDate(false); // 編集モードを終了
  };

  const TermDateEditor = () => {
    return (
      <Box display="flex" alignItems="center">
        {isEditingTermDate ? (
          //
          // 編集モード
          //
          // <div style={{ margin: "0px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={dayjs(termDate.start)}
              views={["year", "month", "day"]}
              onChange={(newValue) =>
                setTermDate((prev) => ({
                  ...prev,
                  start: newValue ? newValue.format("YYYY/MM/DD") : "",
                }))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    readOnly: true,
                  }}
                />
              )}
              inputFormat="YYYY/MM/DD"
            />
            <Typography variant="body2" style={{ margin: "10px" }}>
              ～
            </Typography>
            <DatePicker
              value={dayjs(termDate.end)}
              views={["year", "month", "day"]}
              onChange={(newValue) =>
                setTermDate((prev) => ({
                  ...prev,
                  end: newValue ? newValue.format("YYYY/MM/DD") : "",
                }))
              }
              renderInput={(params) => <TextField {...params} />}
              inputFormat="YYYY/MM/DD"
            />
            <Typography variant="body2" style={{ marginLeft: "10px" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  handleTermDateChange();
                }}
                style={{ cursor: "pointer" }}
                disabled={dayjs(termDate.start).isAfter(dayjs(termDate.end))}
              >
                更新
              </Button>
              {"　"}
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditTermDateCancel();
                }}
                style={{ fontSize: "0.7rem", cursor: "pointer" }}
              >
                戻る
              </Button>
            </Typography>
          </LocalizationProvider>
        ) : (
          // </div>
          //
          // 通常モード
          //
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="body1"
              color="gray"
              style={{ display: "flex", alignItems: "center" }}
            >
              表示期間：{termDate.start} ～ {termDate.end}
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  handleEditTermDateStart();
                }}
                style={{
                  //   background: "none",
                  //   border: "none",
                  //   textDecoration: "underline",
                  //   cursor: "pointer",
                  //   fontSize: "0.9rem",
                  color: "gray",
                  //   // marginLeft: "8px", // EditIconとの間に少し余白を追加
                }}
              >
                <EditIcon />
              </IconButton>
            </Typography>
          </div>
        )}
      </Box>
    );
  };

  /***************************************************
  // テーブルのデータをMUIDataTable用の形式に変換する
  // tableData
  *****************************************************/
  const tableData = procStatusLists
    ? procStatusLists.statusProcesses
        .filter((item) => {
          let statusProcess = item.statusProcess;
          if (
            (props.procMode === "Completed" &&
              (statusProcess.status === MOM_STATUS_COMPLETED ||
                (statusProcess.status !== MOM_STATUS_COMPLETED &&
                  statusProcess.forceCompletion === 1))) ||
            (props.procMode === "Processing" &&
              statusProcess.status !== MOM_STATUS_COMPLETED &&
              statusProcess.forceCompletion === 0)
          ) {
            return true;
          } else {
            return false; // tableData にセットしない
          }
        })
        .map((item) => {
          let statusProcess = item.statusProcess;
          const agencyName = ocrModel2Agency[statusProcess.distributor];
          const procStatusMsg =
            statusProcess.status === 0
              ? statusProcess.runningMessage || ""
              : (
                  procStatuses[statusProcess.status] || {
                    content: "Default Content",
                  }
                ).content;

          const pdfFileName =
            statusProcess.status === MOM_STATUS_MOM_CHECK_REQ
              ? "登録待ち"
              : statusProcess.status === MOM_STATUS_COMPLETED ||
                  statusProcess.status === MOM_STATUS_MOM_API_ERROR
                ? "受注完了"
                : "";

          // PDF ファイル処理
          const fileLinkElement = [];
          let outputLine = false;
          if (statusProcess.pdfFormPath !== "") {
            fileLinkElement.push(
              <a
                key={statusProcess.processNo + statusProcess.pdfFormPath}
                href={statusProcess.pdfFormPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                {pdfFileName}
              </a>
            );
            outputLine = true;
          }
          if (statusProcess.inquiryPdfFormPath !== "") {
            const inquiryFileLink = `${statusProcess.inquiryPdfFormPath}`;
            fileLinkElement.push(
              <React.Fragment key={statusProcess.processNo + "inquiry"}>
                {outputLine ? <br /> : ""}
                <a
                  href={inquiryFileLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  問い合わせ中
                </a>
              </React.Fragment>
            );
            outputLine = true;
          }
          if (statusProcess.errorPdfFormPath !== "") {
            const errorFileLink = `${statusProcess.errorPdfFormPath}`;
            fileLinkElement.push(
              <React.Fragment key={statusProcess.processNo + "error"}>
                {outputLine ? <br /> : ""}
                <a
                  href={errorFileLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  登録エラー{" "}
                </a>
              </React.Fragment>
            );
          }

          return {
            /* 0 */ uploadDate: statusProcess.uploadDate, //[0]
            /* 1 */ momRegistDate: removeYearFromDate(
              statusProcess.momRegisterDate
            ), //[1]
            /* 2 */ agencyName: agencyName, //[LIST_ROW_NO_ARGENCY]
            /* 3 */ orderCount:
              statusProcess.orderCount === "0" ? "" : statusProcess.orderCount, //[3]
            /* 4 */ procStatus: procStatusMsg, //[LIST_ROW_NO_PROC_MSG]
            /* 5 */ action: statusProcess.status.toString(), //[5]
            /* 6 */ pdfFormPath: fileLinkElement, //[6]
            /* 7 */ processNo: statusProcess.processNo, //[LIST_ROW_NO_PROCCESS_NO]
            /* 8 */ deleteIcon: "", //[8]
          };
        })
    : [];

  const LIST_ROW_NO_ARGENCY = 2;
  const LIST_ROW_NO_PROC_MSG = 4;
  const LIST_ROW_NO_PROCCESS_NO = 7;

  /*****************************************************
  // columns
  *****************************************************/
  const columns = [
    {
      /*************************************************************
        申請書登録日時
      **************************************************************/
      name: "uploadDate",
      label: "申請書登録日時",
      options: {
        filter: false,
      },
    },

    /***************************************************************
    　 MOM 登録時間
    ****************************************************************/
    {
      name: "momRegistDate",
      label: "MOM登録日時",
      options: {
        display: props.procMode === "Completed" ? true : false,
        filter: false,
      },
    },
    /***************************************************************
      流通販社
    ****************************************************************/
    {
      name: "agencyName",
      label: "販売会社",
      options: {
        filter: true,
      },
    },
    /***************************************************************
      申請数
    ****************************************************************/
    {
      name: "orderCount",
      label: "申請数",
      options: {
        filter: false,
      },
    },
    /***************************************************************
      処理状況	
    ****************************************************************/
    {
      name: "procStatus",
      label: "処理状況",
      options: {
        filter: true,
      },
    },
    /***************************************************************
      アクション
    ****************************************************************/
    {
      name: "action",
      label: "アクション",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const processNo = tableMeta.rowData[LIST_ROW_NO_PROCCESS_NO];
          const argency = tableMeta.rowData[LIST_ROW_NO_ARGENCY];
          const buttonProps = {
            [MOM_STATUS_RUNNING]: null, // 実行中
            [MOM_STATUS_PDF_ERROR]: null, // PDF展開エラー
            [MOM_STATUS_OCR_ERROR]: null, // OCRシステムエラー
            [MOM_STATUS_PAIR_ERROR]: {
              // 書類の対エラー
              color: "secondary",
              variant: "contained",
              onClick: () => handleSetErrPair(processNo, argency),
            },
            [MOM_STATUS_ORDERFORM_ERROR]: null, // 申請書エラー
            [MOM_STATUS_MOM_CHECK_REQ]: {
              // MOM登録待ち
              color: "primary",
              variant: "outlined",
              onClick: () => handleMomCheckStart(processNo, value),
            },
            [MOM_STATUS_MOM_API_ERROR]: {
              // MOM APIエラー
              color: "secondary",
              variant: "contained",
              onClick: () => handleMomCheckStart(processNo, value),
            },
            [MOM_STATUS_COMPLETED]: {
              // MOM登録完了
              color: "primary",
              variant: "outlined",
              onClick: () => handleMomCheckStart(processNo, value),
            },
          };

          return (
            <>
              {buttonProps[parseInt(value)] ? (
                <ConfirmButton {...buttonProps[parseInt(value)]} />
              ) : null}
              {parseInt(value) === MOM_STATUS_MOM_CHECK_REQ &&
              argency === "DIS" ? (
                <ConfirmButton
                  color="secondary"
                  variant="outlined"
                  label="対再指定"
                  onClick={() => handleSetErrPair(processNo, argency)}
                />
              ) : null}
            </>
          );
        },
        filter: false, // Disable filter for this column
      },
    },
    /***************************************************************
      PDFファイル
    ****************************************************************/
    {
      name: "pdfFormPath",
      label: "申請書",
      options: {
        filter: false, // Disable filter for this column
      },
    },
    /***************************************************************
    　 管理番号
    ****************************************************************/
    {
      name: "processNo",
      label: "管理番号",
      options: {
        display: true,
        filter: false,
      },
    },

    /***************************************************************
    　 移動 ｜ 削除
    ****************************************************************/

    props.procMode === "Completed"
      ? {
          name: "deleteIcon",
          label: "削除",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowData = tableMeta.rowData[LIST_ROW_NO_PROCCESS_NO];
              return (
                <IconButton
                  onClick={() => handleDelete(rowData)}
                  disabled={
                    startAction.processNo !== null ||
                    isSubmitting ||
                    isEditingTermDate
                  }
                >
                  <DeleteIcon />
                </IconButton>
              );
            },
            display: true,
            filter: false,
          },
        }
      : {
          name: "mentenace",
          label: "移動　削除",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowData = tableMeta.rowData[LIST_ROW_NO_PROCCESS_NO];
              return (
                <>
                  <IconButton
                    onClick={() => handleMove(rowData)}
                    disabled={
                      startAction.processNo !== null ||
                      isSubmitting ||
                      !tableMeta.rowData[LIST_ROW_NO_PROC_MSG].includes(
                        "エラー"
                      )
                    }
                  >
                    <MoveDownOutlinedIcon />
                  </IconButton>

                  <IconButton
                    onClick={() => handleDelete(rowData)}
                    disabled={startAction.processNo !== null || isSubmitting}
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              );
            },
            display: true,
            filter: false,
          },
        },
  ];

  /*****************************************************
  // MUIDataTableのオプション
  *****************************************************/
  // テーブルのデータが変更されたときに実行される関数
  const handleTableChange = (action, tableState) => {
    if (action === "sort") {
      const { name, direction } = tableState.sortOrder;
      setSortOrder({ name, direction });
    } else if (action === "filterChange") {
      const filterList = tableState.filterList;
      setFilterArgency(filterList[LIST_ROW_NO_ARGENCY][0]);
      setFilterProcSts(filterList[LIST_ROW_NO_PROC_MSG][0]);
      setFilterArgencyBackup(filterList[LIST_ROW_NO_ARGENCY][0]);
      setFilterProcStsBackup(filterList[LIST_ROW_NO_PROC_MSG][0]);
    }
    simulateResizeEvent(); // ウィンドウサイズを変更する関数を実行
  };

  const options = {
    filter: true,
    filterType: "dropdown",
    print: false,
    download: false,
    sort: true,
    viewColumns: false, // 列の表示・非表示ボタンを非表示にする
    selectableRows: "none", // 行を選択する機能を無効にする
    selectableRowsOnClick: false, // 行をクリックして選択
    textLabels: {
      body: {
        noMatch: "Loading data or no matching data",
      },
    },
    resizableColumns: false,
    fixedHeader: true,
    page: page,
    rowsPerPageOptions: [10, 25, 50],
    rowsPerPage: rowsPerPage,
    fixedSelectColumn: true,
    responsive: "standard",
    sortOrder: sortOrder, // ソートステートを設定

    search: false, // Searchボタンを非表示にする

    onChangePage: handleChangePage, // ページ変更時のイベントハンドラ
    onChangeRowsPerPage: handleChangeRowsPerPage,
    onTableChange: handleTableChange, // MUIDataTableが変化したときのイベントハンドラ

    // 初期のソートステートを設定
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      return null; // デフォルトの削除ボタンを非表示にするため、nullを返す
    },

    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
      return (
        <TableFooter>
          <TableRow>
            <TableCell colSpan={6}>
              <Stack
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Pagination
                  count={Math.ceil(count / rowsPerPage)}
                  page={page + 1} // Paginationコンポーネントは1から始まるため、+1する
                  onChange={(event, newPage) =>
                    handleChangePage(event, newPage)
                  }
                />
                <Typography sx={{ fontSize: "0.8rem" }}>
                  {page * 10 + 1}-
                  {page * 10 + 10 <= count ? page * 10 + 10 : count} of {count}
                </Typography>
              </Stack>
            </TableCell>
          </TableRow>
        </TableFooter>
      );
    },
  };

  /*****************************************************
  // tableRef（フィルター状態再設定
  *****************************************************/
  const [filterArgency, setFilterArgency] = useState("");
  const [filterArgencyBackup, setFilterArgencyBackup] = useState("");
  const [filterProcSts, setFilterProcSts] = useState("");
  const [filterProcStsBackup, setFilterProcStsBackup] = useState("");

  const tableRef = useRef();
  useEffect(() => {
    if (tableRef.current) {
      const filterList = tableRef.current.state.columns.map(() => []);
      filterList[LIST_ROW_NO_ARGENCY] = filterArgency ? [filterArgency] : []; // 販社
      filterList[LIST_ROW_NO_PROC_MSG] = filterProcSts ? [filterProcSts] : []; // 処理状況
      tableRef.current.setState({ filterList });
    }
  }, [filterArgency, filterProcSts]);

  /*****************************************************
  // 処理状況一覧レンダリング
  *****************************************************/
  return (
    <>
      <ThemeProvider theme={theme}>
        <div
          style={{
            cursor: isSubmitting ? "wait" : "default",
            paddingBottom: "120px",
          }}
        >
          {/*****************************************************
          // MOM 登録
          *****************************************************/}
          {startAction.processNo !== null &&
            (startAction.actionKind === MOM_STATUS_UNDEFINE || // 未定義
              startAction.actionKind === MOM_STATUS_MOM_CHECK_REQ || // MOM登録待ち
              startAction.actionKind === MOM_STATUS_MOM_API_ERROR || // MOM APIエラー
              startAction.actionKind === MOM_STATUS_COMPLETED) && ( // MOM登録完了
              <>
                <h3>MOM 登録内容確認</h3>

                <MomTable
                  data={momArray}
                  onSaveMom={onSaveMomData}
                  onSaveBaseMom={onSaveBaseMomData}
                  userEmail={userEmail}
                  processNo={startAction.processNo}
                  enableEdit={
                    startAction.actionKind === MOM_STATUS_UNDEFINE
                      ? retStatusByProcessNo(startAction.processNo) ===
                        MOM_STATUS_COMPLETED
                        ? false
                        : true
                      : startAction.actionKind === MOM_STATUS_MOM_CHECK_REQ
                  } // MOM登録待ち
                  setIsMomEditting={setIsMomEditting}
                />

                <div
                  style={{
                    position: "fixed",
                    bottom: "48px",
                    left: "0px",
                    right: "0px",
                    backgroundColor: "#fff",
                    justifyContent: "space-between",
                    display: "flex",
                    padding: "10px 20px",
                    zIndex: theme.zIndex.drawer - 1,
                    borderTop: "5px solid lightgrey",
                  }}
                >
                  <div style={{ position: "relative", left: "200px" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        handleMomRegistration();
                      }}
                      disabled={
                        isMomEditting !== null ||
                        isSubmitting ||
                        startAction.actionKind === MOM_STATUS_COMPLETED || // 登録完了
                        startAction.actionKind === MOM_STATUS_MOM_API_ERROR || // MOM APIエラー
                        (momArray.momInfos &&
                          momArray.momInfos.some(
                            (info) => parseInt(info.momInfo.momProcStatus) === 0
                          ))
                      }
                    >
                      MOM 登録
                    </Button>{" "}
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleEditRecordCancel}
                      disabled={isSubmitting}
                    >
                      戻る
                    </Button>
                  </div>
                  <div>
                    <Tooltip title="処理状況が「ーーー」のすべてを「受注完了」に設定します">
                      <span>
                        <Button
                          color="primary"
                          onClick={handleSetAllProcEndStatus}
                          disabled={
                            isMomEditting !== null ||
                            isSubmitting ||
                            startAction.actionKind === MOM_STATUS_COMPLETED || // 登録完了
                            startAction.actionKind ===
                              MOM_STATUS_MOM_API_ERROR || // MOM APIエラー
                            (momArray.momInfos &&
                              momArray.momInfos.every(
                                (info) =>
                                  parseInt(info.momInfo.momProcStatus) !== 0
                              ))
                          }
                        >
                          <u>すべてを受注完了に設定</u>
                        </Button>
                      </span>
                    </Tooltip>
                  </div>
                </div>
              </>
            )}
          {/*****************************************************
          // 書類の対 エラー修正
          *****************************************************/}
          {startAction.processNo !== null &&
            startAction.actionKind === MOM_STATUS_PAIR_ERROR &&
            startAction.argency !== "SYNNEX" && (
              <>
                <h3>申請書指定</h3>

                <PairTable
                  formPairList={formPairList}
                  onSave={onSavePairForm}
                />
                <p style={{ marginTop: "40px", marginBottom: "80px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handlePairFormRegistration()}
                    disabled={isSubmitting}
                  >
                    登録
                  </Button>{" "}
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleEditRecordCancel}
                  >
                    戻る
                  </Button>
                </p>
              </>
            )}
          {startAction.processNo !== null &&
            startAction.actionKind === MOM_STATUS_PAIR_ERROR &&
            startAction.argency === "SYNNEX" && (
              <>
                {/* <h4>SYNNEX 申請書指定</h4> */}

                <PairTableSynnex
                  formPairList={formPairList}
                  onSave={onSavePairForm}
                  processNo={startAction.processNo}
                />
                <p style={{ margin: "20px" }}>
                  {/* <p style={{ marginTop: "20px", marginBottom: "80px" }}> */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handlePairFormRegistration()}
                    disabled={isSubmitting}
                  >
                    登 録
                  </Button>{" "}
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleEditRecordCancel}
                  >
                    戻 る
                  </Button>
                </p>
              </>
            )}
          {/*****************************************************
           // 処理状況一覧表
           *****************************************************/}
          {showTable && (
            <>
              <GetInformation
                setUserName={setUserName}
                setUserEmail={setUserEmail}
                setCookie={setCookie}
                removeCookie={removeCookie}
                setVersionId={setVersionId}
              />
              <MUIDataTable
                title={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    style={{
                      padding: isEditingTermDate
                        ? "25px 0 10px 0"
                        : "15px 0 0 0",
                    }}
                  >
                    <IconButton onClick={handleUpdateClick}>
                      <RefreshIcon />
                      <span
                        style={{
                          fontSize: "65%",
                          position: "relative",
                          top: "0.1em",
                          left: "0.1em",
                        }}
                      >
                        Refresh
                      </span>
                    </IconButton>
                    {/* 表示期間 */}
                    {props.procMode === "Completed" && <TermDateEditor />}
                  </Box>
                }
                data={tableData}
                columns={columns}
                options={options}
                ref={tableRef}
              />
            </>
          )}
        </div>
      </ThemeProvider>
    </>
  );
}
